import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import OffersSection from './components/OffersSection';
import CategoriesSection from './components/CategoriesSection';
import BusinessFeatures from './components/BusinessFeatures';
import PopularPicks from './components/PopularPicks';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <OffersSection />
              <CategoriesSection />
              <BusinessFeatures />
              <PopularPicks />
            </>
          } />
          <Route path="/rent" element={<div>Rent Page</div>} />
          <Route path="/buy" element={<div>Buy Furniture Page</div>} />
          <Route path="/wfh" element={<div>WFH Combo Page</div>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 